<template>
  <div class="pa-4" v-allowed="'manage_syllabus'">
    <v-card elevation="0">
      <v-card-actions class="mb-6">
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="readyToLevelUpCount <= 0" color="accent" small
          @click="getReadyToNextLevelInstances()">
          <v-icon size="20">mdi-chevron-double-up</v-icon>
          <span v-if="!isSmallerDisplay()">
            {{ $t('message.ready_to_level_up') }} ({{ readyToLevelUpCount }})
          </span>
        </v-btn>
        <v-btn outlined elevation="0" color="primary" small
          @click="newTemplateDialog = true; selectedTemplate = { useBelts: true }">
          <v-icon size="20">mdi-shape-square-plus</v-icon>
          <span v-if="!isSmallerDisplay()">
            {{ $t('message.new_syllabus') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
    <div v-if="loading" class="text-center">
      <circles-loader />
    </div>
    <div v-else-if="!templates" class="text-center" style="color:gray">
      <h2>{{ $t('message.no_syllabuses') }}</h2>
      <h4>{{ $t('message.no_syllabuses_details') }}</h4>
    </div>
    <div v-else>
      <v-expansion-panels flat>
        <template v-for="(i) in templates">
          <v-expansion-panel :key="i._id" :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
            <v-expansion-panel-header class="text-left" @click="expandSyllabus(i._id)">
              <div>
                <icon-belt v-if="i.useBelts" color="grey" class="mr-2" />
                <v-icon v-else class="mr-1">mdi-school-outline</v-icon>
                <span>{{ i.name }}</span>
                <span style="margin-left:10px;color:gray">{{ i.levels ? i.levels.length : 0 }}
                  {{ $t('message.levels') }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card elevation="0">
                <v-card-text v-html="i.description"></v-card-text>
                <v-card-actions v-if="!isSmallerDisplay()">
                  <v-btn outlined :loading="loadingTemplate" elevation="0" color="primary" small
                    v-if="selectedTemplate ? false : true" @click="selectTemplate(i._id); selectedLevel = null;">{{
                      $t('message.view_details') }}</v-btn>
                  <v-btn outlined elevation="0" color="primary" v-if="selectedTemplate ? true : false" small
                    @click="addLevelDialog = true; selectedLevel = {}">
                    <v-icon size="20">mdi-signal-cellular-outline</v-icon>{{ $t('message.add_level') }}
                  </v-btn>
                  <v-btn outlined elevation="0" color="primary" v-if="selectedTemplate ? true : false" small
                    @click="editTemplateDialog = true">
                    <v-icon size="20">mdi-pencil-box-outline</v-icon>{{ $t('message.edit') }}
                  </v-btn>
                  <v-btn outlined :loading="loadingInstances" elevation="0" color="primary"
                    v-if="selectedTemplate && selectedTemplate.instances && selectedTemplate.instances > 0" small
                    @click="viewActiveInstances()">
                    <v-icon size="20">mdi-eye-outline</v-icon>{{ $t('message.view_instances') }}
                    ({{ selectedTemplate.instances }})
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined elevation="0" color="primary" v-if="selectedTemplate" small
                    @click="duplicateTemplateDialog = true">
                    <v-icon size="20">mdi-content-copy</v-icon>
                    {{ $t('message.create_duplicate') }}
                  </v-btn>
                  <v-btn elevation="0" small color="error" v-if="selectedTemplate"
                    @click="removeTemplateDialog = true;">
                    <v-icon size="20">mdi-trash-can-outline</v-icon>
                    {{ $t('message.archive') }}
                  </v-btn>
                </v-card-actions>
                <div v-else>
                  <v-btn outlined elevation="0" block color="primary" small v-if="selectedTemplate ? false : true"
                    @click="selectTemplate(i._id); selectedLevel = null;">{{ $t('message.view_details') }}</v-btn>
                  <v-btn outlined block class="mt-1" elevation="0" color="primary"
                    v-if="selectedTemplate ? true : false" small @click="addLevelDialog = true; selectedLevel = {}">
                    <v-icon size="20">mdi-signal-cellular-outline</v-icon>{{ $t('message.add_level') }}
                  </v-btn>
                  <v-btn outlined block class="mt-1" elevation="0" color="primary"
                    v-if="selectedTemplate ? true : false" small @click="editTemplateDialog = true">
                    <v-icon size="20">mdi-square-edit-outline</v-icon>{{ $t('message.edit') }}
                  </v-btn>
                  <v-btn outlined :loading="loadingInstances" block class="mt-1" elevation="0" color="primary"
                    v-if="selectedTemplate && selectedTemplate.instances && selectedTemplate.instances > 0" small
                    @click="viewActiveInstances()">
                    <v-icon size="20">mdi-card-search-outline</v-icon>{{ $t('message.view_instances') }}
                    ({{ selectedTemplate.instances }})
                  </v-btn>
                  <v-btn block class="mt-1" elevation="0" v-if="selectedTemplate" small
                    @click="duplicateTemplateDialog = true">
                    <v-icon size="20">mdi-content-copy</v-icon>
                    {{ $t('message.create_duplicate') }}
                  </v-btn>
                  <v-btn block class="mt-1" outlined elevation="0" small color="error" v-if="selectedTemplate"
                    @click="removeTemplateDialog = true;">{{ $t('message.archive') }}</v-btn>
                </div>
                <v-card-text v-if="selectedTemplate">
                  <v-switch hide-details @change="updateTemplate()"
                    :disabled="!(selectedTemplate.levels && selectedTemplate.levels.length == 0)"
                    v-model="selectedTemplate.useBelts" :label="$t('message.use_belts')"></v-switch>
                  <v-switch hide-details v-model="selectedTemplate.displayDetails" @change="updateTemplate()"
                    :label="$t('message.display_progress_details')"></v-switch>
                </v-card-text>
                <v-card-text v-if="selectedTemplate" class="pa-0">
                  <v-expansion-panels flat>
                    <template v-for="(level, index) in selectedTemplate.levels">
                      <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
                        :key="'template_' + level._id + '_level_' + index">
                        <v-expansion-panel-header class="text-left" @click="selectLevel(level)">
                          <div>
                            <belt-display v-if="selectedTemplate.useBelts" :belt="level.level" />
                            <span v-else>
                              <v-icon :color="level.color ? level.color : ''">mdi-signal-cellular-outline
                              </v-icon>{{ level.level }}
                            </span>
                            <span class="supporting-text" style="margin-left:10px">{{ level.rules ? level.rules.length :
                              0 }} {{ $t('message.rules') }}</span>
                          </div>
                          <v-card-actions v-if="!selectedTemplate.useBelts">
                            <v-spacer></v-spacer>
                            <v-btn elevation="0" v-if="level.position != 1 && level.position != 0" small icon
                              @click.stop="updateLevelPosition(level, true)">
                              <v-icon>mdi-arrow-up-drop-circle-outline</v-icon>
                            </v-btn>
                            <v-btn elevation="0" v-if="level.position != selectedTemplate.levels.length" small icon
                              @click.stop="updateLevelPosition(level, false)">
                              <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card-text v-if="selectedTemplate.instances <= 0">
                            <BeltSelectMonthly v-if="selectedTemplate.useBelts && isMonthlyBelt(level.level)"
                              :label="$t('message.level')" v-model="level.level" />
                            <belts-select v-else-if="selectedTemplate.useBelts" :label="$t('message.level')"
                              v-model="level.level" />
                            <v-text-field outlined dense v-else :label="$t('message.level')" v-model="level.level">
                            </v-text-field>
                          </v-card-text>
                          <v-card-text v-else class="text-caption mt-0 pt-0">
                            {{ $t('message.cant_edit_syllabus_level') }}
                          </v-card-text>
                          <v-card-actions v-if="!isSmallerDisplay()">
                            <v-btn outlined elevation="0" small color="primary" @click="addRule(level._id)">
                              <v-icon size="20">mdi-clipboard-check-outline</v-icon>
                              {{ $t('message.add_rule') }}
                            </v-btn>
                            <v-btn outlined elevation="0" small color="primary" v-if="!selectedTemplate.useBelts"
                              @click="editColor(level._id)">
                              <v-icon size="20">mdi-palette-outline</v-icon>
                              {{ $t('message.edit_color') }}
                            </v-btn>
                            <v-btn :loading="updating" outlined elevation="0" small color="primary"
                              v-if="level.totalPercent > 0" :disabled="level.totalPercent != 100"
                              @click="updateLevel()">{{ $t('message.update')
                              }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn elevation="0" small color="error" @click="removeLevel(level)">
                              <v-icon size="20">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <v-card-actions v-else>
                            <v-menu offset-y small>
                              <template v-slot:activator="{ on }">
                                <v-btn outlined block v-on="on" slot="activator" small elevation="0" color="primary">
                                  {{ $t("message.actions") }}
                                </v-btn>
                              </template>
                              <v-list dense>
                                <v-list-item @click="addRule(level._id)">
                                  <v-list-item-title>
                                    {{ $t("message.add_rule") }}
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="!selectedTemplate.useBelts" @click="editColor(level._id)">
                                  <v-list-item-title>
                                    {{ $t("message.edit_color") }}
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="level.totalPercent > 0" :disabled="level.totalPercent != 100"
                                  @click="updateLevel()">
                                  <v-list-item-title>
                                    {{ $t("message.update") }}
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="removeLevel(level)">
                                  <v-list-item-title>
                                    {{ $t("message.remove") }}
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-card-actions>
                          <v-card-text class="pa-0">
                            <div v-if="!level.rules || level.rules.length == 0">
                              <span class="supporting-text">{{ $t('message.no_rules') }}</span>
                            </div>
                            <div v-else>
                              <template v-for="(r, index) in level.rules">
                                <div :key="'level' + level._id + '_rule' + index">
                                  <div v-if="!isSmallerDisplay()">
                                    <v-list-item two-line class="text-left">
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          <v-icon v-if="r.ruleType == 'number'">mdi-chevron-double-up</v-icon>
                                          <v-icon v-else-if="r.ruleType == 'checkins'">mdi-map-marker-outline</v-icon>
                                          <v-icon
                                            v-else-if="r.ruleType == 'checkins_matches'">mdi-map-marker-outline</v-icon>
                                          <v-icon
                                            v-else-if="r.ruleType == 'checkins_contains'">mdi-map-marker-outline</v-icon>
                                          <v-icon v-else-if="r.ruleType == 'video'">mdi-video-outline</v-icon>
                                          <v-icon v-else-if="r.ruleType == 'flowchart'">mdi-sitemap-outline</v-icon>
                                          <v-icon v-else-if="r.ruleType == 'text'">mdi-text-box-outline</v-icon>
                                          <v-icon v-else-if="r.ruleType == 'days'">mdi-calendar-clock</v-icon>
                                          <v-icon v-else>mdi-toggle-switch-off-outline</v-icon>
                                          <b class="ml-1">{{ r.ruleId == 'checkins' ? $t('message.regular_checkins') :
                                            r.ruleId }}</b>
                                        </v-list-item-title>
                                        <v-list-item-title>
                                          <span v-if="r.ruleType == 'number'">{{ $t('message.level_rule_number')
                                            }}</span>
                                          <span v-else-if="r.ruleType == 'checkins'">{{ $t('message.level_rule_number')
                                            }}</span>
                                          <span v-else-if="r.ruleType == 'checkins_matches'">{{
                                            $t('message.matching_checkins') }}</span>
                                          <span v-else-if="r.ruleType == 'checkins_contains'">{{
                                            $t('message.containing_checkins') }}</span>
                                          <span v-else-if="r.ruleType == 'video'">{{ $t('message.video') }}</span>
                                          <span v-else-if="r.ruleType == 'flowchart'">{{ $t('message.flowchart')
                                            }}</span>
                                          <span v-else-if="r.ruleType == 'text'">{{ $t('message.text') }}</span>
                                          <span v-else-if="r.ruleType == 'days'">{{ $t('message.level_rule_days')
                                            }}</span>
                                          <span v-else>{{ $t('message.level_rule_boolean') }}</span>
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <v-list-item-content>
                                        <v-list-item-title class="pa-2">
                                          <v-text-field outlined dense :label="$t('message.number')"
                                            v-if="isTypeNumber(r.ruleType) || r.ruleType == 'days'"
                                            :rules="[rules.number]" v-model="r.numberNeeded"></v-text-field>
                                          <v-text-field outlined dense :label="$t('message.text')"
                                            v-if="r.ruleType == 'checkins_matches'" v-model="r.text"></v-text-field>
                                          <v-text-field outlined dense :label="$t('message.text')"
                                            v-else-if="r.ruleType == 'checkins_contains'"
                                            v-model="r.text"></v-text-field>
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <v-list-item-action class="pa-2">
                                        <v-text-field dense outlined @change="getLevelPercent()"
                                          :label="$t('message.percent')" v-model="r.percent"></v-text-field>
                                      </v-list-item-action>
                                      <v-list-item-action>
                                        <v-btn icon text x-small @click="removeRuleFromLevel(index)">
                                          <v-icon size="20">mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </v-list-item-action>
                                    </v-list-item>
                                    <div v-if="r.ruleType == 'video'"
                                      :key="'level' + level._id + '_rule_video_' + index" class="text-left mt-0">
                                      <v-autocomplete :label="$t('message.video')" :items="availableVideos"
                                        item-text="title" item-value="_id" v-model="r.video" clearable outlined
                                        dense></v-autocomplete>
                                    </div>
                                    <div v-else-if="r.ruleType == 'flowchart'"
                                      :key="'level' + level._id + '_rule_flowchart_' + index" class="text-left mt-0">
                                      <FlowchartsSelect outlined dense v-model="r.flowchart">
                                      </FlowchartsSelect>
                                    </div>
                                    <div v-else-if="r.ruleType == 'text'"
                                      :key="'level' + level._id + '_rule_longtext_' + index" class="text-left mt-0">
                                      <v-textarea :label="$t('message.text')" v-model="r.longText" outlined
                                        dense></v-textarea>
                                    </div>
                                    <div :key="'level' + level._id + '_rule_details_' + index" class="text-left mt-0">
                                      <v-text-field outlined dense
                                        :label="$t('message.details') + ' (' + $t('message.optional').toLowerCase() + ')'"
                                        counter maxlength="200" v-model="r.details"></v-text-field>
                                    </div>
                                    <div :key="'level' + level._id + '_rule_category_' + index" class="text-left mt-0">
                                      <v-text-field outlined dense
                                        :label="$t('message.category') + ' (' + $t('message.optional').toLowerCase() + ')'"
                                        counter maxlength="200" v-model="r.category"></v-text-field>
                                    </div>
                                  </div>
                                  <div v-else class="mt-1">
                                    <div class="mb-1">
                                      <v-list-item-title>
                                        <b>{{ r.ruleId == 'checkins' ? $t('message.regular_checkins') : r.ruleId }}</b>
                                      </v-list-item-title>
                                      <v-list-item-title>
                                        <span v-if="r.ruleType == 'number'">{{ $t('message.level_rule_number') }}</span>
                                        <span v-else-if="r.ruleType == 'days'">{{ $t('message.level_rule_days')
                                          }}</span>
                                        <span v-else-if="r.ruleType == 'checkins'">{{ $t('message.level_rule_number')
                                          }}</span>
                                        <span v-else-if="r.ruleType == 'checkins_matches'">{{
                                          $t('message.matching_checkins') }}</span>
                                        <span v-else-if="r.ruleType == 'checkins_contains'">{{
                                          $t('message.containing_checkins') }}</span>
                                        <span v-else-if="r.ruleType == 'flowchart'">{{ $t('message.flowchart') }}</span>
                                        <span v-else>{{ $t('message.level_rule_boolean') }}</span>
                                      </v-list-item-title>
                                    </div>
                                    <div>
                                      <div>
                                        <v-text-field outlined dense :label="$t('message.number')"
                                          v-if="isTypeNumber(r.ruleType) || r.ruleType == 'days'"
                                          :rules="[rules.number]" v-model="r.numberNeeded" type="number"></v-text-field>
                                        <v-text-field outlined dense :label="$t('message.text')"
                                          v-if="r.ruleType == 'checkins_matches'" v-model="r.text"></v-text-field>
                                        <v-text-field outlined dense :label="$t('message.text')"
                                          v-else-if="r.ruleType == 'checkins_contains'" v-model="r.text"></v-text-field>
                                      </div>
                                      <div>
                                        <v-text-field dense outlined @change="getLevelPercent()"
                                          :label="$t('message.percent')" v-model="r.percent"
                                          type="number"></v-text-field>
                                      </div>
                                    </div>
                                    <div>
                                      <v-text-field outlined dense elevation="0"
                                        :label="$t('message.details') + ' (' + $t('message.optional').toLowerCase() + ')'"
                                        counter maxlength="200" v-model="r.details"></v-text-field>
                                    </div>
                                    <div class="mb-2">
                                      <v-btn block small elevation="0" @click="removeRuleFromLevel(index)">
                                        <v-icon size="20">mdi-trash-can-outline</v-icon>
                                        {{ $t('message.delete') }}
                                      </v-btn>
                                    </div>
                                  </div>
                                  <v-divider :key="index + '_divider'"></v-divider>
                                </div>
                              </template>
                              <v-card-actions v-if="selectedLevel">
                                <v-spacer></v-spacer>
                                <b>Total:</b> <span
                                  :style="'margin-left:5px;' + (selectedLevelPercent == 100 ? 'color:green' : 'color:red')">{{
                                    selectedLevelPercent }}%</span>
                              </v-card-actions>
                            </div>
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </template>
                  </v-expansion-panels>
                </v-card-text>
                <v-card-actions v-if="selectedTemplate && selectedTemplate.copyOf" class="supporting-text">
                  <v-icon>mdi-content-copy</v-icon>
                  <v-avatar v-if="!selectedTemplate.copyOf.sameSystem" size="20"
                    :title="selectedTemplate.copyOf.academyName">
                    <ImageDisplay v-if="selectedTemplate.copyOf.academyImage"
                      :src="selectedTemplate.copyOf.academyImage" />
                  </v-avatar>
                  <span style="margin-left:5px">{{ $t('message.copy_of') }}:
                    {{ selectedTemplate.copyOf.templateName }}</span>
                  <span v-if="!selectedTemplate.copyOf.sameSystem" style="margin-left:5px">({{
                    selectedTemplate.copyOf.academyName
                    }})</span>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
    </div>
    <v-dialog v-model="newTemplateDialog" fullscreen v-if="selectedTemplate">
      <v-card>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ $t('message.new_syllabus_template') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="newTemplateDialog = false; selectedTemplate = null">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.name')" v-model="selectedTemplate.name"></v-text-field>
          <v-textarea outlined :label="$t('message.description')" v-model="selectedTemplate.description"></v-textarea>
          <v-switch hide-details :disabled="selectedTemplate.levels && selectedTemplate.levels.length > 0"
            v-model="selectedTemplate.useBelts" :label="$t('message.use_belts')"></v-switch>
          <span v-if="selectedTemplate.useBelts" class="supporting-text">{{ $t('message.use_belts_explained') }}</span>
          <span v-else class="supporting-text">{{ $t('message.define_levels_explained') }}</span>
          <v-switch hide-details v-model="selectedTemplate.displayDetails"
            :label="$t('message.display_progress_details')">
          </v-switch>
          <span class="supporting-text">{{ $t('message.display_progress_details_explained') }}</span>
        </v-card-text>
        <v-card-text v-if="!selectedTemplate._id">
          <v-switch hide-details v-model="selectedTemplate.quickCreate"
            :label="$t('message.automatic_levels')"></v-switch>
          <div v-if="selectedTemplate.quickCreate && !selectedTemplate.useBelts">
            <v-text-field outlined dense :hint="$t('message.comma_separated_levels')" :label="$t('message.levels')"
              v-model="selectedTemplate.levelsString"></v-text-field>
          </div>
          <div v-else-if="selectedTemplate.quickCreate">
            <v-switch hide-details v-model="selectedTemplate.includeAdults"
              :label="$t('message.include_adult_belts')"></v-switch>
            <v-switch hide-details v-model="selectedTemplate.includeKids"
              @change="onIncludeKidsChange"
              :label="$t('message.include_kid_belts')"></v-switch>
            <v-switch hide-details v-if="selectedTemplate.includeKids" v-model="selectedTemplate.useMonthlySystem"
              :label="$t('message.kids_monthly_system')"></v-switch>
            <v-switch hide-details v-model="selectedTemplate.includeStripes"
              :label="$t('message.include_stripes')"></v-switch>
          </div>
          <div v-if="selectedTemplate.quickCreate && ((!selectedTemplate.useBelts && selectedTemplate.levelsString) || (selectedTemplate.useBelts && (selectedTemplate.includeAdults || selectedTemplate.includeKids)))" class="mt-4">
            <div class="text-subtitle-2 mb-2">{{ $t('message.rules') }}</div>
            <span class="supporting-text">{{ $t('message.rules_percent_explained') }}</span>
            <div v-if="predefinedRules.length == 0" class="supporting-text mt-1">{{ $t('message.no_rules') }}</div>
            <div v-for="(r, index) in predefinedRules" :key="'predef_rule_' + index">
              <div v-if="!isSmallerDisplay()">
                <v-list-item two-line class="text-left">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon v-if="r.ruleType == 'number'">mdi-chevron-double-up</v-icon>
                      <v-icon v-else-if="r.ruleType == 'checkins'">mdi-map-marker-outline</v-icon>
                      <v-icon v-else-if="r.ruleType == 'checkins_matches'">mdi-map-marker-outline</v-icon>
                      <v-icon v-else-if="r.ruleType == 'checkins_contains'">mdi-map-marker-outline</v-icon>
                      <v-icon v-else-if="r.ruleType == 'video'">mdi-video-outline</v-icon>
                      <v-icon v-else-if="r.ruleType == 'flowchart'">mdi-sitemap-outline</v-icon>
                      <v-icon v-else-if="r.ruleType == 'text'">mdi-text-box-outline</v-icon>
                      <v-icon v-else-if="r.ruleType == 'days'">mdi-calendar-clock</v-icon>
                      <v-icon v-else>mdi-toggle-switch-off-outline</v-icon>
                      <b class="ml-1">{{ r.ruleId == 'checkins' ? $t('message.regular_checkins') : r.ruleId }}</b>
                    </v-list-item-title>
                    <v-list-item-title>
                      <span v-if="r.ruleType == 'number'">{{ $t('message.level_rule_number') }}</span>
                      <span v-else-if="r.ruleType == 'checkins'">{{ $t('message.level_rule_number') }}</span>
                      <span v-else-if="r.ruleType == 'checkins_matches'">{{ $t('message.matching_checkins') }}</span>
                      <span v-else-if="r.ruleType == 'checkins_contains'">{{ $t('message.containing_checkins') }}</span>
                      <span v-else-if="r.ruleType == 'video'">{{ $t('message.video') }}</span>
                      <span v-else-if="r.ruleType == 'flowchart'">{{ $t('message.flowchart') }}</span>
                      <span v-else-if="r.ruleType == 'text'">{{ $t('message.text') }}</span>
                      <span v-else-if="r.ruleType == 'days'">{{ $t('message.level_rule_days') }}</span>
                      <span v-else>{{ $t('message.level_rule_boolean') }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="pa-2">
                      <v-text-field outlined dense :label="$t('message.number')"
                        v-if="isTypeNumber(r.ruleType) || r.ruleType == 'days'" :rules="[rules.number]"
                        v-model="r.numberNeeded"></v-text-field>
                      <v-text-field outlined dense :label="$t('message.text')" v-if="r.ruleType == 'checkins_matches'"
                        v-model="r.text"></v-text-field>
                      <v-text-field outlined dense :label="$t('message.text')"
                        v-else-if="r.ruleType == 'checkins_contains'" v-model="r.text"></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action class="pa-2">
                    <v-text-field dense outlined :label="$t('message.percent')" v-model="r.percent"></v-text-field>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn icon text x-small @click="removePredefinedRule(index)">
                      <v-icon size="20">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <div v-if="r.ruleType == 'video'" :key="'predef_rule_video_' + index" class="text-left mt-0">
                  <v-autocomplete :label="$t('message.video')" :items="availableVideos" item-text="title"
                    item-value="_id" v-model="r.video" clearable outlined dense></v-autocomplete>
                </div>
                <div v-else-if="r.ruleType == 'flowchart'" :key="'predef_rule_flowchart_' + index"
                  class="text-left mt-0">
                  <FlowchartsSelect outlined dense v-model="r.flowchart"></FlowchartsSelect>
                </div>
                <div v-else-if="r.ruleType == 'text'" :key="'predef_rule_longtext_' + index" class="text-left mt-0">
                  <v-textarea :label="$t('message.text')" v-model="r.longText" outlined dense></v-textarea>
                </div>
                <div :key="'predef_rule_details_' + index" class="text-left mt-0">
                  <v-text-field outlined dense
                    :label="$t('message.details') + ' (' + $t('message.optional').toLowerCase() + ')'" counter
                    maxlength="200" v-model="r.details"></v-text-field>
                </div>
                <div :key="'predef_rule_category_' + index" class="text-left mt-0">
                  <v-text-field outlined dense
                    :label="$t('message.category') + ' (' + $t('message.optional').toLowerCase() + ')'" counter
                    maxlength="200" v-model="r.category"></v-text-field>
                </div>
              </div>
              <div v-else class="mt-1">
                <div class="mb-1">
                  <v-list-item-title>
                    <b>{{ r.ruleId == 'checkins' ? $t('message.regular_checkins') : r.ruleId }}</b>
                  </v-list-item-title>
                  <v-list-item-title>
                    <span v-if="r.ruleType == 'number'">{{ $t('message.level_rule_number') }}</span>
                    <span v-else-if="r.ruleType == 'days'">{{ $t('message.level_rule_days') }}</span>
                    <span v-else-if="r.ruleType == 'checkins'">{{ $t('message.level_rule_number') }}</span>
                    <span v-else-if="r.ruleType == 'checkins_matches'">{{ $t('message.matching_checkins') }}</span>
                    <span v-else-if="r.ruleType == 'checkins_contains'">{{ $t('message.containing_checkins') }}</span>
                    <span v-else-if="r.ruleType == 'flowchart'">{{ $t('message.flowchart') }}</span>
                    <span v-else>{{ $t('message.level_rule_boolean') }}</span>
                  </v-list-item-title>
                </div>
                <div>
                  <v-text-field outlined dense :label="$t('message.number')"
                    v-if="isTypeNumber(r.ruleType) || r.ruleType == 'days'" :rules="[rules.number]"
                    v-model="r.numberNeeded" type="number"></v-text-field>
                  <v-text-field outlined dense :label="$t('message.text')" v-if="r.ruleType == 'checkins_matches'"
                    v-model="r.text"></v-text-field>
                  <v-text-field outlined dense :label="$t('message.text')" v-else-if="r.ruleType == 'checkins_contains'"
                    v-model="r.text"></v-text-field>
                  <v-text-field dense outlined :label="$t('message.percent')" v-model="r.percent"
                    type="number"></v-text-field>
                </div>
                <div>
                  <v-text-field outlined dense elevation="0"
                    :label="$t('message.details') + ' (' + $t('message.optional').toLowerCase() + ')'" counter
                    maxlength="200" v-model="r.details"></v-text-field>
                </div>
                <div class="mb-2">
                  <v-btn block small elevation="0" @click="removePredefinedRule(index)">
                    <v-icon size="20">mdi-trash-can-outline</v-icon>
                    {{ $t('message.delete') }}
                  </v-btn>
                </div>
              </div>
              <v-divider></v-divider>
            </div>
            <v-card-actions class="pa-0 mt-2">
              <v-btn small elevation="0" outlined @click="addRuleToPredefined()">
                <v-icon size="18" class="mr-1">mdi-plus</v-icon>{{ $t('message.add_rule') }}
              </v-btn>
              <v-spacer></v-spacer>
              <b>Total:</b>
              <span class="ml-1" :style="predefinedRulesPercent == 100 ? 'color:green' : 'color:red'">
                {{ predefinedRulesPercent }}%
              </span>
            </v-card-actions>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn outlined small elevation="0" color="primary" :disabled="!canAddTemplate" @click="addTemplate()">{{
            $t('message.add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editTemplateDialog" max-width="90%" v-if="selectedTemplate">
      <v-card outlined>
        <v-card-title>{{ $t('message.edit_syllabus_template') }}</v-card-title>
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.name')" v-model="selectedTemplate.name"></v-text-field>
          <v-textarea outlined dense :label="$t('message.description')" v-model="selectedTemplate.description">
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" @click="editTemplateDialog = false">{{ $t('message.cancel')
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined small elevation="0" color="primary" @click="updateTemplate()">{{ $t('message.update')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addLevelDialog" max-width="90%" v-if="selectedLevel && selectedTemplate">
      <v-card class="pa-2" outlined>
        <v-row>
          <v-card-title class="ml-5">{{ $t('message.add_level_syllabus_template') }}</v-card-title>
          <v-switch v-if="selectedTemplate.useBelts" v-model="useMonthlySystem"
            :label="$t('message.kids_monthly_system')"></v-switch>
        </v-row>
        <v-card-text class="pt-6">
          <belt-select v-if="selectedTemplate.useBelts && !useMonthlySystem" :label="$t('message.level')"
            v-model="selectedLevel.level" />
          <belt-select-monthly v-if="selectedTemplate.useBelts && useMonthlySystem" :label="$t('message.level')"
            v-model="selectedLevel.level" />
          <v-text-field v-if="!selectedTemplate.useBelts" outlined dense :label="$t('message.level')"
            v-model="selectedLevel.level"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" @click="addLevelDialog = false;">{{ $t('message.cancel')
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small outlined nelevation="0" color="primary" @click="addTemplateLevel()">{{ $t('message.add')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addRuleDialog" max-width="90%" v-if="selectedLevel && newRule">
      <v-card outlined class="pa-2">
        <v-card-title class="text-subtitle-1">{{ $t('message.add_rule') }}</v-card-title>
        <v-card-text>
          <div>
            <v-select outlined dense v-model="newRule.ruleType" :items="ruleTypes" :label="$t('message.rule_type')">
            </v-select>
            <v-alert type="info" v-if="newRule.ruleType">
              {{ $t('message.' + 'level_rule_' + newRule.ruleType + '_explained') }}
            </v-alert>
            <v-text-field outlined dense :label="$t('message.name')" v-model="newRule.ruleId" counter maxlength="40">
            </v-text-field>
            <v-text-field outlined dense :label="$t('message.details')" v-model="newRule.details" counter
              maxlength="200"></v-text-field>
            <v-text-field v-if="isTypeNumber(newRule.ruleType)" outlined dense :label="$t('message.number')"
              v-model="newRule.numberNeeded" type="number"></v-text-field>
            <v-text-field v-if="newRule.ruleType == 'days'" outlined dense
              :label="capitalizeFirstLetter($t('message.days'))" v-model="newRule.numberNeeded"
              type="number"></v-text-field>
            <v-text-field v-if="newRule.ruleType == 'checkins_contains'" outlined dense
              :label="$t('message.containing_checkins')" v-model="newRule.text"></v-text-field>
            <v-text-field v-if="newRule.ruleType == 'checkins_matches'" outlined dense
              :label="$t('message.matching_checkins')" v-model="newRule.text"></v-text-field>
            <FlowchartsSelect v-if="newRule.ruleType == 'flowchart'" outlined dense v-model="newRule.flowchart">
            </FlowchartsSelect>
            <v-autocomplete v-if="newRule.ruleType == 'video'" :label="$t('message.video')" :items="availableVideos"
              item-text="title" item-value="_id" v-model="newRule.video" clearable outlined dense></v-autocomplete>
            <v-textarea v-if="newRule.ruleType == 'text'" outlined dense :label="$t('message.text')"
              v-model="newRule.longText"></v-textarea>
            <v-text-field outlined dense :label="$t('message.level_percent')" :rules="[rules.number]"
              v-model="newRule.percent" type="number"></v-text-field>
          </div>
          <span class="supporting-text">{{ $t('message.rules_percent_explained') }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" @click="addRuleDialog = false;">{{ $t('message.cancel')
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined small elevation="0" color="primary"
            :disabled="!newRule.ruleId || !newRule.ruleType || !newRule.percent" @click="addRule2Level()">{{
              $t('message.add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editLevelColorDialog" max-width="90%" v-if="selectedLevel">
      <v-card outlined>
        <h3 class="pa-3 mt-2 ml-6">{{ $t('message.edit_color') }}</h3>
        <v-card-text>
          <v-color-picker dot-size="50" hide-canvas hide-inputs hide-sliders mode="hexa" show-swatches
            swatches-max-height="250" v-model="selectedColor"></v-color-picker>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-btn small elevation="0" class="outlined-btn ml-2" @click="editLevelColorDialog = false;">{{
            $t('message.cancel')
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small elevation="0" color="primary" @click="updateLevelColor()">{{ $t('message.update')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeLevelDialog" max-width="90%" v-if="selectedLevel">
      <v-card outlined>
        <v-card-text>
          <h3>{{ $t('message.are_you_sure') }}</h3>
          <span class="supporting-text">{{ $t('message.delete_level_explained') }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" class="outlined-btn" @click="removeLevelDialog = false; selectedLevel = null;">
            {{ $t('message.cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="error" @click="confirmRemoveLevel()">{{ $t('message.delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeTemplateDialog" max-width="90%" v-if="selectedTemplate">
      <v-card outlined>
        <v-card-title>{{ $t('message.are_you_sure') }}</v-card-title>
        <v-card-text>
          <div>{{ $t('message.archive_syllabus_explained') }}</div>
          <span class="supporting-text">{{ $t('message.cant_be_undone') }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" class="outlined-btn" @click="removeTemplateDialog = false;">{{ $t('message.cancel')
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small elevation="0" color="error" @click="archiveTemplate()">{{ $t('message.archive') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="duplicateTemplateDialog" max-width="90%" v-if="selectedTemplate">
      <v-card class="pa-2" outlined>
        <v-card-text class="mt-6">
          <h2>{{ $t('message.duplicate_syllabus') }}</h2>
        </v-card-text>
        <v-card-text>
          <v-switch v-if="affiliates" v-model="showAffiliates" :label="$t('message.duplicate_for_affiliate_academy')">
          </v-switch>
          <v-select outlined dense v-if="affiliates && showAffiliates" :label="$t('message.select_affiliate')"
            :items="affiliates" item-text="name" item-value="_id" v-model="selectedAffiliate" clearable></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" @click="duplicateTemplateDialog = false;">{{
            $t('message.cancel')
            }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined small elevation="0" color="primary" @click="duplicateTemplate()">{{
            $t('message.create_duplicate')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="instancesDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card outlined>
        <v-toolbar flat class="opposite--text" color="primary" dense>
          <v-toolbar-title>
            {{ $t('message.active_instances') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="opposite" elevation="0" icon dark @click="instancesDialog = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list three-line subheader v-if="activeInstances">
          <template v-for="(i, index) in activeInstances">
            <v-list-item :key="index + '_' + i._id" @click="goToMember(i.user._id, i.user.displayName)">
              <v-list-item-avatar>
                <ImageDisplay v-if="i.user.userImageSmall" :src="i.user.userImageSmall" :title="i.user.displayName" />
                <img v-else :src="assets('default-profile-avatar.png')" :title="i.user.displayName" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span v-html="i.user.displayName"></span>
                </v-list-item-title>
                <v-list-item-title class="supporting-text">
                  {{ $t('message.initialized') }}: {{ $d(new Date(i.createdOn), "month_day_year", $i18n.locale) }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <SyllabusProgress :template="selectedTemplate" :instance="i"></SyllabusProgress>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn :loading="i.loadingNextLevels" icon
                  @click.stop="loadNextLevel(i)"><v-icon>mdi-chevron-double-up</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < activeInstances.length" :key="index"></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignLevelDialog" max-width="80%">
      <v-card class="text-xs-left" v-if="selectedInstance" elevation="0" outlined>
        <v-card-text>
          <div class="mb-1">
            <div class="text-subtitle-1" v-if="!selectedInstance.nextLevel">
              {{ $t('message.no_next_level_available') }}
            </div>
            <div v-else class="text-subtitle-1">
              {{ $t('message.suggested_next_level') }}:
            </div>
          </div>
          <div>
            <v-switch
              v-if="selectedInstance.useBelts && ((selectedInstance.user && selectedInstance.user.isMinor) || (!selectedInstance.user))"
              v-model="selectedInstance.useMonthlySystem" :label="$t('message.kids_monthly_system')"></v-switch>
          </div>
          <BeltSelectMonthly v-if="selectedInstance.useMonthlySystem" :belts="selectedInstance.availableLevels"
            v-model="selectedInstance.nextLevel">
          </BeltSelectMonthly>
          <BeltsSelect v-else-if="selectedInstance.useBelts" :belts="selectedInstance.availableLevels"
            v-model="selectedInstance.nextLevel">
          </BeltsSelect>
          <v-autocomplete outlined v-else v-model="selectedInstance.nextLevel" :items="selectedInstance.availableLevels"
            :label="$t('message.select_level')" clearable></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" @click="assignLevelDialog = false; selectedInstance = null">{{
            $t("message.cancel")
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="selectedInstance.updating" outlined small elevation="0" color="primary"
            @click="assignLevel()">{{
              $t("message.update")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="readyToLevelUpDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card outlined>
        <v-toolbar flat class="opposite--text" color="primary" dense>
          <v-toolbar-title>
            {{ $t('message.ready_to_level_up') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="opposite" elevation="0" icon dark @click="readyToLevelUpDialog = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list three-line subheader v-if="readyToLevelUpInstances">
          <template v-for="(i, index) in readyToLevelUpInstances">
            <v-list-item :key="index + '_' + i._id" @click="goToMember(i.user._id, i.user.displayName)">
              <v-list-item-avatar>
                <ImageDisplay v-if="i.user.userImageSmall" :src="i.user.userImageSmall" :title="i.user.displayName" />
                <img v-else :src="assets('default-profile-avatar.png')" :title="i.user.displayName" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span v-html="i.user.displayName"></span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ i.template }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="i.useBelts" class="supporting-text">
                  <b>{{ $t('message.current_level') }}</b>: {{ $t('message.' + i.level) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else class="supporting-text">
                  <b>{{ $t('message.current_level') }}</b>: {{ i.level }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content>
                <SyllabusProgress :instance="i"></SyllabusProgress>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn :loading="i.loadingNextLevels" icon
                  @click.stop="loadNextLevel(i)"><v-icon>mdi-chevron-double-up</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < readyToLevelUpInstances.length" :key="index"></v-divider>
          </template>
        </v-list>
        <div v-else>
          <h2>{{ $t('message.empty') }}</h2>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BeltDisplay from "@/components/displays/BeltDisplay.vue";
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import SyllabusProgress from "@/components/displays/SyllabusProgressDisplay.vue";
import IconBelt from "@/components/displays/icons/IconBelt.vue";
import BeltSelect from "@/components/inputs/BeltSelect.vue";
import BeltSelectMonthly from "@/components/inputs/BeltSelectMonthly.vue";
import BeltsSelect from "@/components/inputs/BeltsSelectStripes.vue";
import FlowchartsSelect from "@/components/inputs/FlowchartsSelect.vue";
import Api from "@/services/Api2";
//For drag and drop functionslity: https://www.npmjs.com/package/vuedraggable

export default {
  components: {
    CirclesLoader,
    BeltsSelect,
    BeltSelect,
    BeltSelectMonthly,
    BeltDisplay,
    IconBelt,
    SyllabusProgress,
    FlowchartsSelect
  },
  data() {
    return {
      useMonthlySystem: false,
      loading: true,
      templates: null,
      newTemplateDialog: false,
      selectedTemplate: null,
      addLevelDialog: null,
      selectedColor: null,
      selectedLevel: null,
      newRule: null,
      updating: false,
      editTemplateDialog: null,
      addRuleDialog: null,
      selectedLevelPercent: 0,
      predefinedRules: [
        { ruleType: 'checkins', ruleId: 'checkins', percent: 40, numberNeeded: 100 },
        { ruleType: 'days', ruleId: '2 years', percent: 40, numberNeeded: 730 },
        { ruleType: 'boolean', ruleId: 'Professor Approval', percent: 20, numberNeeded: 0 },
      ],
      readyToLevelUpCount: 0,
      removeLevelDialog: false,
      showAffiliates: false,
      duplicateTemplateDialog: false,
      affiliates: null,
      availableVideos: [],
      selectedAffiliate: null,
      readyToLevelUpDialog: false,
      removeTemplateDialog: false,
      editLevelColorDialog: false,
      assignLevelDialog: null,
      selectedInstance: null,
      loadingInstances: false,
      instancesDialog: null,
      activeInstances: null,
      loadingTemplate: false,
      readyToLevelUpInstances: null,
      ruleTypes: [
        { text: this.$t('message.level_rule_number'), value: "number" },
        { text: this.$t('message.level_rule_boolean'), value: "boolean" },
        { text: this.$t('message.level_rule_checkins'), value: "checkins" },
        { text: this.$t('message.level_rule_checkins_contains'), value: "checkins_contains" },
        { text: this.$t('message.level_rule_checkins_matches'), value: "checkins_matches" },
        { text: this.$t('message.level_rule_days'), value: "days" },
        { text: this.$t('message.level_rule_text'), value: "text" },
        { text: this.$t('message.level_rule_video'), value: "video" },
        { text: this.$t('message.level_rule_flowchart'), value: "flowchart" }],
      rules: {
        number: value => {
          const pattern = /^\d+$/
          return pattern.test(value) || this.$t("message.not_a_number")
        },
      },
    };
  },
  created() {
    this.getTemplates();
    this.getReadyToNextLevelUpCount();
    this.getAffiliateAcademies();
    this.getVideos();
  },
  computed: {
    canAddTemplate() {
      const t = this.selectedTemplate;
      if (this.predefinedRulesPercent !== 100) return false;
      if (t?.['quickCreate']) {
        if (t?.['useBelts']) return !!(t?.['includeAdults'] || t?.['includeKids']);
        return !!(t?.['levelsString'] && t?.['levelsString'].trim());
      }
      return true;
    },
    predefinedRulesPercent() {
      let total = 0;
      for (const r of this.predefinedRules) {
        total += new Number(r.percent).valueOf();
      }
      return total;
    },
  },
  watch: {
  },
  methods: {
    assignLevel() {
      if (!this.selectedInstance.nextLevel) {
        this.showAlert("error", this.$t('message.assign_next_level'));
        return;
      }
      this.selectedInstance.updating = true;
      const escapedLevelToAssign = this.selectedInstance.nextLevel.replace(/\//g, "%2F");
      Api()
        .post("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + this.selectedInstance._id + "/level/" + escapedLevelToAssign)
        .then(response => {
          if (response) {
            this.viewActiveInstances();
            this.selectedInstance = null;
            this.assignLevelDialog = null;
          }
        })
        .catch(e => {
          console.log(e)
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    loadNextLevel(item) {
      const instanceId = item.instanceId;
      this.selectedInstance = item;
      item.loadingNextLevels = true;
      Api()
        .get(
          "syllabus/managedacademy/" +
          this.$store.state.managedAcademy +
          "/instances/" +
          instanceId +
          "/levels"
        )
        .then((response) => {
          if (response && response.data) {
            this.selectedInstance.availableLevels = response.data.list;
            this.selectedInstance.nextLevel = response.data.next;
            this.selectedInstance.useBelts = response.data.useBelts;
            this.assignLevelDialog = true;
            item.loadingNextLevels = false;
          }
        });
    },
    getVideos() {
      Api()
        .get("videos/admins/" + this.$store.state.managedAcademy + '/titles/all')
        .then(response => {
          const data = response.data;
          if (data.videos && data.videos.length > 0) {
            this.availableVideos = data.videos;
          }
        });
    },
    duplicateTemplate() {
      let data = {
        destination: this.showAffiliates && this.selectedAffiliate ?
          this.selectedAffiliate : null,
        template: this.selectedTemplate._id
      };
      Api()
        .post("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/duplicate/" + this.selectedTemplate._id,
          data)
        .then(response => {
          if (response) {
            this.showAlert("success", this.$t('message.success'));
            if (!data.destination)
              this.getTemplates();
            this.duplicateTemplateDialog = false;
            this.showAffiliates = false;
            this.selectedAffiliate = null;
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    getAffiliateAcademies() {
      Api()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/affiliates")
        .then(response => {
          if (response.data && response.data.academies && response.data.academies.length > 0)
            this.affiliates = response.data.academies;
        });
    },
    isTypeNumber(ruleType) {
      if (ruleType == 'number')
        return true;
      if (ruleType == 'checkins')
        return true;
      if (ruleType == 'checkins_contains')
        return true;
      if (ruleType == 'checkins_matches')
        return true;
      return false;
    },
    getReadyToNextLevelUpCount() {
      Api()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/ready/to/next/level/count")
        .then(response => {
          if (response) {
            this.readyToLevelUpCount = response.data.count;
          }
        })
    },
    getReadyToNextLevelInstances() {
      this.readyToLevelUpDialog = true;
      this.readyToLevelUpInstances = null;
      Api()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/ready/to/next/level")
        .then(response => {
          if (response) {
            if (response.data.instances) {
              this.readyToLevelUpInstances = response.data.instances;
              this.readyToLevelUpDialog = true;
            }
          }
        })
    },
    viewActiveInstances() {
      if (!this.selectedTemplate)
        return;
      this.loadingInstances = true;
      this.activeInstances = null;
      Api()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/template/" + this.selectedTemplate._id)
        .then(response => {
          if (response) {
            if (response.data.instances) {
              this.activeInstances = response.data.instances;
              this.instancesDialog = true;
              this.loadingInstances = false;
            }
          }
        })
    },
    updateLevelColor() {
      if (this.selectedColor) {
        const newColor = this.selectedColor.hex ? this.selectedColor.hex : this.selectedColor;
        this.selectedLevel.color = newColor;
        this.updateLevel();
        this.editLevelColorDialog = false;
      }
    },
    updateLevelPosition(level, up) {
      let newPosition = 0;
      let oldPosition = level.position;
      if (up && level.position > 0)
        newPosition = oldPosition - 1;
      else
        newPosition = oldPosition + 1;
      Api()
        .patch("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + this.selectedTemplate._id + "/levels/" + level._id + '/position',
          { newPosition: newPosition, oldPosition: oldPosition })
        .then(response => {
          if (response) {
            if (response)
              this.selectedTemplate.levels = response.data.levels;
            //Replace levels
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    updateLevel() {
      if (this.selectedLevel) {
        this.updating = true;
        Api()
          .patch("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + this.selectedTemplate._id + "/levels/" + this.selectedLevel._id,
            this.selectedLevel)
          .then(response => {
            if (response) {
              if (response)
                this.showAlert("success", this.$t('message.updated'));
              this.updating = false;
            }
          })
          .catch(e => {
            if (e)
              this.showAlert("error", "Oops!", this.$t('message.error_generic'));
            this.updating = false;
          });
      } else {
        this.showAlert("error", "Oops!", this.$t('message.selecc_level'));
        this.updating = false;
      }
    },
    addRule2Level() {
      if (this.selectedLevel) {
        if (this.newRule.ruleType == 'checkins')
          this.newRule.ruleId = 'checkins';
        if ((this.newRule.ruleType == 'checkins_contains' || this.newRule.ruleType == 'checkins_matches')
          && !this.newRule.text) {
          this.showAlert("error", "Oops!", this.$t('message.fill_all_params'));
          return;
        }
        if (!this.selectedLevel.rules)
          this.selectedLevel.rules = [];
        if (this.newRule.percent)
          this.newRule.percent = new Number(this.newRule.percent).valueOf();
        if (this.newRule.numberNeeded)
          this.newRule.numberNeeded = new Number(this.newRule.numberNeeded).valueOf();
        let proceed = true;
        for (const rule of this.selectedLevel.rules) {
          if (rule.ruleId == this.newRule.ruleId) {
            proceed = false;
            break;
          }
        }
        if (proceed) {
          this.selectedLevel.rules.push(this.newRule);
          this.addRuleDialog = false;
          this.getLevelPercent();
        } else {
          this.showAlert("error", "Oops!", this.$t('message.rule_already_exists'));
        }
      }
    },
    removeRuleFromLevel(index) {
      if (this.selectedLevel && this.selectedLevel.rules) {
        this.selectedLevel.rules.splice(index, 1);
      }
      this.getLevelPercent();
    },
    selectLevel(level) {
      this.selectedLevel = level;
      this.getLevelPercent();
    },
    getLevelPercent() {
      let total = 0;
      if (this.selectedLevel && this.selectedLevel.rules) {
        for (const r of this.selectedLevel.rules) {
          total += new Number(r.percent).valueOf();
        }
        this.selectedLevel.totalPercent = total;
        this.selectedLevelPercent = total;
      }
    },
    addRule() {
      this.addRuleDialog = true;
      this.newRule = {};
    },
    editColor() {
      this.editLevelColorDialog = true;
      if (this.selectedLevel.color)
        this.selectedColor = this.selectedLevel.color;
    },
    removeLevel(level) {
      this.selectedLevel = level;
      this.removeLevelDialog = true;
    },
    confirmRemoveLevel() {
      if (this.selectedLevel) {
        Api()
          .delete("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + this.selectedTemplate._id + "/levels/" + this.selectedLevel._id)
          .then(response => {
            if (response) {
              let index = 0;
              for (const level of this.selectedTemplate.levels) {
                if (level._id == this.selectedLevel._id) {
                  this.selectedTemplate.levels.splice(index, 1);
                  this.removeLevelDialog = false;
                  break;
                }
                index++;
              }
            }
          })
          .catch(e => {
            if (e)
              this.showAlert("error", "Oops!", this.$t('message.' + e.response.data.message_code));
          });
      }
    },
    getTemplates() {
      Api()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/templates")
        .then(response => {
          if (response) {
            this.loading = false;
            this.templates = response.data.templates && response.data.templates.length > 0 ? response.data.templates : null
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
          this.loading = false;
        });
    },
    addTemplateLevel() {
      let data = this.selectedLevel;
      Api()
        .post("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + this.selectedTemplate._id + "/levels", data)
        .then(response => {
          if (response) {
            this.addLevelDialog = false;
            this.selectedLevel = response.data.newLevel;
            this.selectedTemplate.levels = response.data.levels;
            this.showAlert("success", this.$t('message.success'));
          }
        })
        .catch(e => {
          if (e.response.status)
            this.showAlert("error", "Oops!", this.$t('message.' + e.response.data.error_code));
        });
    },
    onIncludeKidsChange() {
      if (!this.selectedTemplate.includeKids) this.selectedTemplate.useMonthlySystem = false;
    },
    addRuleToPredefined() {
      this.selectedLevel = { rules: this.predefinedRules };
      this.addRule();
    },
    removePredefinedRule(index) {
      this.predefinedRules.splice(index, 1);
      this.recalcPredefinedPercent();
    },
    addTemplate() {
      if (!this.selectedTemplate) return;
      this.selectedTemplate.predefinedRules = this.predefinedRules;
      Api()
        .post("syllabus/academy/" + this.$store.state.managedAcademy + "/templates", this.selectedTemplate)
        .then(response => {
          if (response) {
            if (!this.templates) this.templates = [response.data.template];
            else this.templates.push(response.data.template);
            this.selectedTemplate = null;
            this.selectedLevel = null;
            this.predefinedRules = [
              { ruleType: 'checkins', ruleId: 'checkins', percent: 40, numberNeeded: 100 },
              { ruleType: 'days', ruleId: '2 years', percent: 40, numberNeeded: 730 },
              { ruleType: 'boolean', ruleId: 'Professor Approval', percent: 20, numberNeeded: 0 },
            ];
            this.newTemplateDialog = false;
            this.showAlert("success", this.$t('message.success'));
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    selectTemplate(id) {
      this.selectedTemplate = null;
      this.loadingTemplate = true;
      Api()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + id)
        .then(response => {
          if (response) {
            this.selectedTemplate = response.data.template;
            if (!this.selectedTemplate.useBelts) {
              let levelColors = {};
              for (const level of this.selectedTemplate.levels) {
                const color = level.color;
                if (color)
                  levelColors[level.level] = color;
              }
              this.selectedTemplate.colors = levelColors;
            }
            this.selectedTemplate.instances = response.data.instances;
            if (response.data.copyOf)
              this.selectedTemplate.copyOf = response.data.copyOf;
          }
          this.loadingTemplate = false;
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    updateTemplate(remove) {
      if (remove)
        this.selectedTemplate.active = false;
      if (this.selectedTemplate && this.selectedTemplate._id) {
        Api()
          .patch("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + this.selectedTemplate._id,
            this.selectedTemplate)
          .then(response => {
            if (response) {
              this.editTemplateDialog = false;
              this.removeTemplateDialog = false;
              this.getTemplates();
              this.showAlert("success", this.$t('message.updated'));
            }
          })
          .catch(e => {
            if (e)
              this.showAlert("error", "Oops!", this.$t('message.error_generic'));
          });
      }
    },
    archiveTemplate() {
      Api()
        .delete("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + this.selectedTemplate._id)
        .then(response => {
          if (response) {
            this.editTemplateDialog = false;
            this.removeTemplateDialog = false;
            this.getTemplates();
            this.showAlert("success", this.$t('message.updated'));
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    expandSyllabus(id) {
      if (id && this.templates && this.templates.length > 1)
        this.selectedTemplate = null;
    },
    hasRule(rule) {
      if (this.selectedLevel) {
        if (this.selectedLevel.rules && this.selectedLevel.rules.length > 0) {
          for (const r of this.selectedLevel.rules) {
            if (r.ruleId == rule)
              return true;
          }
        }
      }
      return false;
    }
  }
};
</script>

<style scoped></style>